export const GET_PREFERENCES = 'GET_PREFERENCES'
export const UPDATE_PREFERENCES = 'UPDATE_PREFERENCES'
export const UPDATE_WANT_GENDER_FLAG = 'UPDATE_WANT_GENDER_FLAG'
export const RESET_PREFERENCES = 'RESET_PREFERENCES'
